import { TranslationUtils } from '@modules/src/utils/TranslationUtils'
import { toCurrencySymbol } from '@modules/src/panel/PanelUtils'
import Facade from '@/Facade'

export class TickerMessageManager {
    public static formatWinAmount(rawWinAmount: number): string {
        if (!Number.isFinite(rawWinAmount)) {
            return '0.00'
        }

        return (rawWinAmount / 100).toFixed(2)
    }

    public static resolveLinePaysMessage(combination: any): string {
        const winAmount = Number(combination?.win_currency)

        if (!Number.isFinite(winAmount) || winAmount <= 0) {
            return ''
        }

        const currency = String(Facade.model?.initData?.player?.currency ?? '')
        const currencySymbol = toCurrencySymbol(currency)
        const formattedWin = TickerMessageManager.formatWinAmount(winAmount)
        const amount = currencySymbol ? `${currencySymbol} ${formattedWin}` : formattedWin

        // The server leaves payline_number unset for cluster wins, so fall back to plain prefix.
        const paylineNumber = Number(combination?.payline_number || 0)

        if (paylineNumber > 0) {
            const key = 'Line {0} Pays {1}'
            const translated = TranslationUtils.translate(key, [paylineNumber, amount])

            return translated === key ? `Line ${paylineNumber} Pays ${amount}` : translated
        }

        return TranslationUtils.translate('Line Pays {0}', [amount])
    }

    public static reassertLineByLineMessage(params: {
        container: any
        isLineByLineActive: boolean
        lineByLineMessage: string
        isTickerClaimedByFeatureMessage: () => boolean
        setTickerMessage: (container: any, message: string) => boolean
    }): void {
        const {
            container,
            isLineByLineActive,
            lineByLineMessage,
            isTickerClaimedByFeatureMessage,
            setTickerMessage,
        } = params

        // Signal callbacks are synchronous, so this lands after same-tick callbacks.
        queueMicrotask(() => {
            if (!isLineByLineActive || !lineByLineMessage || isTickerClaimedByFeatureMessage()) {
                return
            }

            if (!container || container.destroyed) {
                return
            }

            setTickerMessage(container, lineByLineMessage)
        })
    }
}
